'use client';

import React, { useState, useEffect, useRef } from 'react';
import Icon from '@/components/ui/AppIcon';

const NewsletterSection = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setIsHydrated(true);

    // Cleanup timeout on unmount
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      timeoutRef.current = setTimeout(() => {
        setEmail('');
        setIsSubmitted(false);
      }, 3000);
    }
  };

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-gradient-to-br from-secondary/10 to-accent/10 rounded-3xl p-8 lg:p-12 text-center space-y-6">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white rounded-full">
            <Icon name="EnvelopeIcon" size={20} variant="solid" className="text-primary" />
            <span className="text-sm font-medium text-primary">Stay Connected</span>
          </div>

          <h2 className="text-3xl lg:text-4xl font-headline font-semibold text-foreground">
            Get Pet Care Tips & Adoption Updates
          </h2>

          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Join our community of 50,000+ pet lovers. Receive expert care advice, new pet alerts, and heartwarming success stories directly to your inbox.
          </p>

          {isHydrated && (
            <form onSubmit={handleSubmit} className="max-w-md mx-auto">
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  required
                  className="flex-1 px-6 py-4 rounded-lg border-2 border-border focus:border-primary focus:outline-none transition-colors"
                />
                <button
                  type="submit"
                  disabled={isSubmitted}
                  className="px-8 py-4 bg-brand-cta text-white font-headline font-semibold rounded-lg hover:shadow-elevated hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitted ? 'Subscribed!' : 'Subscribe'}
                </button>
              </div>
            </form>
          )}

          <div className="flex flex-wrap items-center justify-center gap-6 pt-4 text-sm text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircleIcon" size={16} variant="solid" className="text-success" />
              <span>Weekly Care Tips</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircleIcon" size={16} variant="solid" className="text-success" />
              <span>New Pet Alerts</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircleIcon" size={16} variant="solid" className="text-success" />
              <span>Success Stories</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;